import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { BRAND, COMPANY, CONTACT } from "@/lib/constants";
import Logo from "@/components/Logo";

const Addr = ({ title, lines }) => (
  <div>
    <h3 className="text-sm font-bold text-white mb-2">{title}</h3>
    <address className="not-italic text-[14px] leading-relaxed text-slate-300">
      {lines.map((l) => <div key={l}>{l}</div>)}
    </address>
  </div>
);

export default function Footer() {
  const col = "text-[14.5px] text-slate-300 hover:text-white transition-colors";
  return (
    <footer className="hp-ink" data-testid="site-footer">
      <div className="hp-rule" aria-hidden="true" />
      <div className="hop-container pt-16 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <Logo size={56} />
              <div>
                <div className="font-display text-2xl font-semibold text-white leading-tight">{BRAND.name}</div>
                <div className="text-sm text-slate-300">{BRAND.tagline}</div>
              </div>
            </div>
            <p className="mt-6 text-[15px] leading-relaxed text-slate-300 max-w-md">
              A brand and operating platform of <span className="text-white font-semibold">{COMPANY.legalName}</span>.
            </p>
            <div className="mt-6 flex flex-col gap-2.5">
              <a href={CONTACT.emailHref} className={`${col} inline-flex items-center gap-2`}><Mail className="w-4 h-4" aria-hidden="true" />{CONTACT.email}</a>
              <a href={CONTACT.phoneHref} className={`${col} inline-flex items-center gap-2`}><Phone className="w-4 h-4" aria-hidden="true" />{CONTACT.phoneDisplay}</a>
              <a href={CONTACT.whatsappHref} target="_blank" rel="noopener noreferrer" className={col}>WhatsApp us</a>
              <a href={CONTACT.linkedinHref} target="_blank" rel="noopener noreferrer" className={col}>LinkedIn</a>
            </div>
          </div>

          <nav aria-label="Footer" className="lg:col-span-4 grid grid-cols-2 gap-8">
            <div>
              <h3 className="text-sm font-bold text-white mb-3">Capabilities</h3>
              <ul className="space-y-2.5">
                <li><Link className={col} to="/what-we-do">House of Projects</Link></li>
                <li><Link className={col} to="/hiring">Hiring &amp; Talent</Link></li>
                <li><Link className={col} to="/insights">Why Now: India data</Link></li>
                <li><Link className={col} to="/arise-and-echo">Arise &amp; Echo</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-bold text-white mb-3">Company</h3>
              <ul className="space-y-2.5">
                <li><Link className={col} to="/how-we-work">How We Work</Link></li>
                <li><Link className={col} to="/about">About</Link></li>
                <li><Link className={col} to="/contact">Contact</Link></li>
                <li><Link className={col} to="/company-information">Company information</Link></li>
              </ul>
            </div>
          </nav>

          <div className="lg:col-span-3 space-y-6">
            <Addr title="Office" lines={COMPANY.registeredOffice} />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <dl className="flex flex-wrap gap-x-7 gap-y-1 text-[12.5px] text-slate-400">
            {[["CIN", COMPANY.cin]].map(([k, v]) => (
              <div key={k} className="flex gap-1.5"><dt className="font-semibold text-slate-300">{k}</dt><dd>{v}</dd></div>
            ))}
          </dl>
          <p className="text-[12.5px] text-slate-400">
            &copy; {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.
            {" "}<Link to="/admin/login" className="text-slate-500 hover:text-slate-300" aria-label="Staff sign in">Staff</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
